<h2>Angaben zur Firma / Organisation</h2>

<p>
  Bitte beachten Sie bei den Angaben zur Person, dass diese Person als Administrator bei uns registriert wird.
  Bei Lizenzen ab mindestens 50 Zugriffen kann der Administrator nach erfolgreichem Login im SPR+ Expert Planungstool
  weitere Benutzer erstellen und verwalten.
</p>

<p>
  Die mit einem Stern markierten Felder sind Pflichtfelder.
</p>

<form id="registrationForm" class="twoColumnForm" #f="ngForm">

  <input id="adminSalutation" name="adminSalutation" placeholder="Anrede" [(ngModel)]="organization.adminSalutation"/>
  <div></div>

  <input id="adminFirstName" name="adminFirstName" placeholder="Vorname *" type="text" maxlength="100" required [(ngModel)]="organization.adminFirstName"/>
  <input id="adminLastName" name="adminLastName" placeholder="Nachname *" type="text" maxlength="100" required [(ngModel)]="organization.adminLastName"/>

  <input id="organizationName" name="organizationName" placeholder="Firma *" type="text" maxlength="255" required [(ngModel)]="organization.organizationName"/>
  <div></div>

  <input id="contactAddressLine1" name="contactAddressLine1" placeholder="Adresse 1 *" type="text" maxlength="100" required [(ngModel)]="organization.contactAddressLine1"/>
  <input id="contactAddressLine2" name="contactAddressLine2" placeholder="Adresse 2" type="text" maxlength="100" [(ngModel)]="organization.contactAddressLine2"/>

  <input id="contactPostalCode" name="contactPostalCode*" placeholder="PLZ *" type="text" maxlength="100" required [(ngModel)]="organization.contactPostalCode"/>
  <input id="contactCity" name="contactCity" placeholder="Ort *" type="text" maxlength="100" required [(ngModel)]="organization.contactCity"/>

  <select id="contactCountryCode" name="contactCountryCode" required [(ngModel)]="organization.contactCountryCode">
    <option *ngFor="let country of availableCountries" [value]="country.code">{{country.name}}</option>
  </select>
  <div></div>

  <input id="contactEmail" name="contactEmail" placeholder="Email *" type="email" maxlength="100" email required [(ngModel)]="organization.contactEmail"/>
  <input id="contactPhone" name="contactPhone" placeholder="Telefon *" type="tel" pattern="[0+][0-9][-0-9 /()]+" maxlength="100" required title="Nummer muss mit + oder 0 beginnen" [(ngModel)]="organization.contactPhone"/>

  <textarea id="newLicenseRemarks" name="newLicenseRemarks" placeholder="Mitteilungen" rows="5" maxlength="2000" [(ngModel)]="organization.newLicenseRemarks"></textarea>
  <div></div>

  <label for="isSameBillingAddress">Diese Adresse ist auch die Rechnungsadresse</label>
  <input id="isSameBillingAddress" name="isSameBillingAddress" type="checkbox" [(ngModel)]="organization.isSameBillingAddress"/>

</form>

<div class="buttonRow">
  <button (click)="appController.next(f)">Weiter</button>
</div>
